import { BaseModel } from 'src/app/shared/models/base.model';

export class Email extends BaseModel {
  email: string;
  email_type: string;
  primary: boolean;
  send_notification: boolean;
  obs: string;
  deleted: boolean;

  constructor() {
    super();
    this.deleted = false;
    this.email_type = 'P';
    this.primary = false;
    this.send_notification = true;
  }

  getMapFields() {
    return {
      email: 'Email',
      email_type: 'Tipo Email',
      primary: 'Primário',
      send_notification: 'Enviar Notificações',
      obs: 'Observações',
      deleted: 'Deletado',
    };
  }
}
